<template>
  <v-list three-line>
    <v-list-tile
      v-if="Array.isArray(notes)"
    >
      <v-list-tile-action class="font-weight-bold subheading">
        {{ $t('Notes') }}
      </v-list-tile-action>
      <v-list-tile-avatar/>
      <v-list-tile-content>
        {{ Array.isArray(notes) ? notes.join('; ') : notes }}
      </v-list-tile-content>
    </v-list-tile>

    <v-list-tile
      v-for="(elements, index) in notes"
      v-else
      :key="index"
    >
      <v-list-tile-action class="font-weight-bold subheading">
        {{ index }}
      </v-list-tile-action>
      <v-list-tile-avatar/>
      <v-list-tile-content>
        {{ Array.isArray(elements) ? elements.join('; ') : elements }}
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</template>

<script>
export default {
  name: 'LineItemNotes',

  props: {
    notes: {
      type: [Array, Object],
      required: true
    }
  }
}
</script>
